module.exports = __webpack_public_path__ + "static/assets/5fc509440394ea09375d8a124eafe728.svg";